import React from 'react';
import { LinearProgress } from 'material-ui/Progress';
import {
    Button,
    Grid,
    MenuItem,
    Paper,
    TextField,
    Tooltip,
    Typography,
    withStyles,
} from 'material-ui';
import ReservationStatusRender from '../ReservationStatusRender';
import ReservationDetailsRender from '../ReservationDetailsRender';
import ReservationPricesRender from '../ReservationPricesRender';
import { netPrice } from '../../../defaultValues/netPrice';
import getValue from '../../../defaultValues/getValue';
import ModifyDatesView from './ModifyDatesView';
import HotelHeaderRender from '../HotelHeaderRender';
import OLYWebPageComponent from '../../OLYWebPageComponent';
import CheckIcon from 'material-ui-icons/Check';
import EditIcon from 'material-ui-icons/Edit';
import RoomIcon from 'material-ui-icons/Hotel';
import UpdateIcon from 'material-ui-icons/Update';
import UndoIcon from 'material-ui-icons/Undo';
import RemoveIcon from 'material-ui-icons/HighlightOff';
import _cloneDeep from 'lodash.clonedeep';
import {
    getAvailabilityReservation,
    getReservationById
} from '../../Reservations/reservationsServices';

import classNames from 'classnames';

import ReservationAvailabilityDialog from './ReservationAvailabilityDialog';
import ReservationObservationsDialog from './ReservationObservationsDialog';
import { translate } from 'react-i18next';
import DynIcon from '../../Utils/DynIcon';
import ObservationsChecksRender from '../ObservationsChecksRender';
import ReservationObservationsRender from '../ReservationObservationsRender';
import ReservationTermsRender from '../ReservationTermsRender';

const styles = theme => ({
    title: {
        fontWeight: 700,
        fontSize: '16px',
    },
    colTitle: {
        fontWeight: 700,
        fontSize: '14px',
        textTransform: 'uppercase',
        border: 0,
        textAlign: 'center',
        height: '40px',
        color: '#555',
    },
    firstColTitle: {
        textAlign: 'left',
        paddingLeft: '16px',
        marginRight: '-16px'
    },
    colValue: {
        fontWeight: 300,
        fontSize: '14px',
        border: 0,
        textAlign: 'center',
        height: '40px',
        paddingTop: '12px',
    },
    colValueEdit: {
        fontWeight: 300,
        fontSize: '12px',
        border: 0,
        textAlign: 'center',
        height: '40px',
        paddingTop: '12px',
    },
    buttonLabel: {
        fontSize: '12px',
        // paddingLeft: '4px',
        fontWeight: 300,
        textDecoration: 'none',
    },
    buttonContainer: {
        marginLeft: '0px',
    },
    button: {
        width: '220px',
        textAlign: 'left'
    },
    kidsAge: {
        paddingRight: '12px',
    },
    textFieldInput: {
        fontSize: '14px',
    },
    fixedMealPlan: {
        fontSize: '14px',
        fontWeight: 300,
        paddingTop: '8px',
    },
    changeTooltipContainer: {
        textAlign: 'left',
        marginLeft: '-24px',
        marginRight: '24px',
        marginTop: '4px'
    },
    expandIcon: {
        color: theme.palette.primary.main
    },
    updateIcon: {
        color: theme.palette.primary.main
    },
    bookingTitle: {
        color: theme.palette.primary.main,
        padding: '20px 0 20px 25px',
        fontWeight: 'bold',
        fontSize: '1.2rem'
    },
    locatorTitle: {
        color: theme.palette.primary.contrastText,
        fontSize: '16px',
        fontWeight: 300,
    },
    expansionPanelFilter: {
        backgroundColor: theme.palette.primary.main
    },
    paperFrame: {
        margin: '40px 0px 30px 0px'
    }
});

class ReservationModifyView extends OLYWebPageComponent {
    static MAX_ROOMS = 10;

    constructor(props) {
        super(props);

        //Para futuro tracking y ademas para tener un navigation correcto.
        this.pageName = 'ReservationModifyView';
        this.pageReference = '';

        let reservationIdAux = '';
        this.state = {
            reservationId: reservationIdAux,
            loading: true,
            info: props.t('BOOKING_DETAIL.ACCESSING_BOOKING_DETAIL'),
            operationstatus: 'error',
            operationtitle: 'Usted va a modificar esta reserva',
            operationtext: '',
            /** the original reservation */
            reservation: null,
            /** the reservation after all modifications were applied */
            modifiedReservation: null,
            /** availability obtaned after querying with conditions added after all modifications */
            availabilityData: null,
            isModalOpen: false,
            isInEditMode: false,
            obsInEditMode: false,
            observations: '',
            disableAvailabilityButton: true,
            observationsChecks: [
                { value: 2, checked: false, label: 'CONFIRM_BOOKING.DOBLE_BED' },
                { value: 3, checked: false, label: 'CONFIRM_BOOKING.TWO_BEDS' },
                { value: 4, checked: false, label: 'CONFIRM_BOOKING.TOP_FLOOR' },
                { value: 5, checked: false, label: 'CONFIRM_BOOKING.GROUND_FLOOR' },
                { value: 6, checked: false, label: 'CONFIRM_BOOKING.CLIENT_WHITOUT_VOUCHER' },
                { value: 7, checked: false, label: 'CONFIRM_BOOKING.LATE_ARRIVAL' },
                { value: 10, checked: false, label: 'CONFIRM_BOOKING.COT' },
                { value: 8, checked: false, label: 'CONFIRM_BOOKING.ADJOINING_ROOMS' },
                { value: 9, checked: false, label: 'CONFIRM_BOOKING.INTERCONNECTING_ROOMS' }
            ]
        };
        window.scrollTo(0, 0);
    }   

    openModal() {
        this.setState({ isModalOpen: true });
    }

    roomIsEqual(originalRoom, newRoom) {
        if (originalRoom && newRoom) {
            return (
                originalRoom.adults === newRoom.adults &&
                originalRoom.kids.length === newRoom.kids.length &&
                originalRoom.mealPlan === newRoom.mealPlan &&
                originalRoom.service.code === newRoom.serviceCode
            );
        }
        return false;
    }

    getRoomsDiff = (originalRooms, newRooms) => {
        if (originalRooms && newRooms) {
            if (originalRooms.length !== newRooms.length) {
                return true;
            }
            let diff = originalRooms.map((or, index) => this.roomIsEqual(or, newRooms[index]));

            return diff.reduce((acc, element) => {
                acc = acc && element;
                return acc;
            }, true);
        } else {
            return false;
        }
    };

    getReservationDiff = rooms => {
        const reservation = this.state.reservation;
        const modifiedReservation = this.state.modifiedReservation;
        return {
            checkIn: reservation.checkIn !== modifiedReservation.checkIn,
            checkOut: reservation.checkOut !== modifiedReservation.checkOut,
            nights: reservation.nights !== modifiedReservation.nights,
            rooms: !this.getRoomsDiff(reservation.rooms, rooms),
        };
    };

    closeModal = rooms => {
        if (rooms && rooms.length) {
            let newrooms = [];
            rooms.forEach(room => {
                let roomcopy = { ...room.option };
                roomcopy.adults = room.adults;
                roomcopy.kids = room.kids;
                roomcopy.order = room.order;
                newrooms.push(roomcopy);
            });

            let modifiedData = JSON.parse(localStorage.getItem('reservationModificationData'));

            if (modifiedData) {
                modifiedData.reservation = this.state.reservation;
                modifiedData.modificationData = {
                    requestCode: this.state.availabilityData.requestCode,
                    checkIn: this.state.availabilityData.checkin,
                    nights: this.state.modifiedReservation.nights,
                    rooms: newrooms,
                };
                modifiedData.diff = this.getReservationDiff(newrooms);
                modifiedData.observations = this.state.observations;

                localStorage.setItem('reservationModificationData', JSON.stringify(modifiedData));
            } else {
                let aux = {
                    reservation: this.state.reservation,
                    modificationData: {
                        requestCode: this.state.availabilityData.requestCode,
                        checkIn: this.state.availabilityData.checkin,
                        nights: this.state.modifiedReservation.nights,
                        rooms: newrooms || this.state.reservation.rooms,
                    },
                    diff: this.getReservationDiff(newrooms),
                    observations: this.state.observations,
                };

                localStorage.setItem('reservationModificationData', JSON.stringify(aux));
            }

            this.setState({ isModalOpen: false });
            window.location.href = '/#/bookings/' + this.state.reservation.olympiaLocator + '/confirm';
        } else {
            localStorage.setItem('reservationModificationData', JSON.stringify(null));
            this.setState({ isModalOpen: false });
        }
    };

    pageTitleParts() {
        let parts = super.pageTitleParts();
        parts.push(this.requestCode);
        return parts;
    }

    onHashChanged = hashObject => {
        //este hash responde a /misreservas/U18X000066X02/cancelar
        if (hashObject && hashObject.parts && hashObject.parts.length > 1) {
            let reservationIdAux = hashObject.parts[1];
            let fichaopen = hashObject.parts.includes('fichaopen');
            if (reservationIdAux) {
                this.requestCode = reservationIdAux;
                //tengo que pedir el objeto RESERVA al API
                this.setState(
                    {
                        expanded: fichaopen,
                        reservationId: reservationIdAux,
                    },
                    () => {
                        this.openReservationFromServer();
                    },
                );
            }
        }
    };

    getAvailabilityReservation = async () => {
        let modifiedReservation = this.state.modifiedReservation;
        let preprocessedRooms = this.preprocessModifiedReservation(modifiedReservation);
        let opts = {
            requestCode: this.state.reservationId,
            checkInDate: modifiedReservation.checkIn,
            nights: modifiedReservation.nights,
            rooms: preprocessedRooms,
            reservation: this.state.modifiedReservation
        };
        this.setState({ loading: true });
        let result = await getAvailabilityReservation(opts);
        this.setState({ loading: false });
        return result;
    };

    preprocessModifiedReservation = modifiedReservation => {
        // remove reservations marked as deleted
        let nonRemovedRooms = modifiedReservation.rooms.filter(room => room.isDeleted !== true);

        // create as many room reservations as set in the roomCount value
        let preprocessedRooms = [];
        nonRemovedRooms.forEach(r => {
            if (Number.isInteger(r.roomCount)) {
                for (let i = 0; i < r.roomCount; i++) {
                    preprocessedRooms.push(r);
                }
            }
        });

        return preprocessedRooms;
    };

    openReservationFromServer = () => {
        this.setState({ loading: true });

        getReservationById(this.state.reservationId).then(async (reservation) => {
            const obs = reservation.observationsProveedor;
            const modifiedReservation = this.decorateRooms(reservation);
            let isdisa = false;
            if (!reservation.allowedActions.includes('MODIFY')) {
                isdisa = true;
            }
            await this.setState({
                loading: false,
                reservation: reservation,
                info: this.props.t('BOOKING_DETAIL.ACCESSING_BOOKING_DETAIL'),
                operationstatus: 'error',
                operationtitle: 'Usted va a modificar esta reserva',
                operationtext: '',
                modifiedReservation: modifiedReservation,
                observations: obs,
                disableAvailabilityButton: isdisa,
            });
            this.getObservations();
            this.getObservationsChecks();
            if (isdisa) {
                alert(this.props.t('COMMON.YOU_CANNOT_MODIFY'));
            }

        }).catch(e => {
            alert(e.message);
        });
    };

    decorateRooms = reservationdata => {
        let modifiedReservation = Object.assign({}, reservationdata);
        modifiedReservation.rooms = modifiedReservation.rooms
            .map(r => Object.assign(_cloneDeep(r), { roomCount: 1, originalMealPlan: r.mealPlan }));
        modifiedReservation.rooms.forEach(room => {
            room.kids = room.kidsAges.map(ka => {
                return { age: ka };
            });
        });

        return modifiedReservation;
    };

    handleDateChange = (checkIn, nights) => {
        let modifiedReservation = this.state.modifiedReservation;
        modifiedReservation.checkIn = checkIn.format('DD/MM/YYYY');
        modifiedReservation.checkOut = checkIn
            .clone()
            .add(nights, 'days')
            .format('DD/MM/YYYY');
        modifiedReservation.nights = nights;
        modifiedReservation.dateUpdated = true;
        this.setState({ modifiedReservation });
        this.disableAvailabilityButton();
    };

    handleSubmit = () => {
        if (!this.state.reservation.allowedActions.includes('MODIFY')) {
            alert(this.props.t('COMMON.YOU_CANNOT_MODIFY'));
            return;
        }
        window.scrollTo(0, 0);
        this.setState({ info: '' });
        this.getAvailabilityReservation().then(data => {
            this.setState({ isModalOpen: true, availabilityData: data, availabilityError: undefined });
        }).catch(error => {
            this.setState({ isModalOpen: true, loading: false, availabilityData: null, availabilityError: error.message });
        });
    };

    handleModifyObservationsClick = () => {
        this.setState({ obsInEditMode: true });
    };

    closeObservationsModal = obs => {
        let reservation = this.state.reservation;
        const { hotelObservations } = this.state.reservation;
        const observations = hotelObservations.map(val => {
            if (val.id === 1) val.description = obs;
            return val;
        });
        reservation.hotelObservations = observations;
        this.setState({ obsInEditMode: false, reservation: reservation, observations: obs });
    };

    handleMealPlanChange = (roomIx, mealPlan) => {
        let mr = _cloneDeep(this.state.modifiedReservation);
        let room = mr.rooms[roomIx];
        room.isUpdated = room.isUpdated || room.mealPlan !== mealPlan;
        room.mealPlan = mealPlan;
        room.mealPlanDescription = this.props.t(`MEALPLANS.${mealPlan}`);
        mr.rooms[roomIx] = room;
        this.setState({ modifiedReservation: mr },
            this.disableAvailabilityButton);
    };

    handleAdultChange = (roomIx, adults) => {
        let mr = _cloneDeep(this.state.modifiedReservation);
        let room = mr.rooms[roomIx];
        room.isUpdated = room.isUpdated || room.adults !== adults;
        room.adults = adults;
        mr.rooms[roomIx] = room;
        this.setState({ modifiedReservation: mr },
            this.disableAvailabilityButton);
    };

    handleKidsChange = (roomIx, kids) => {

        let mr = _cloneDeep(this.state.modifiedReservation);
        mr.rooms[roomIx].kids = Array.from(Array(kids), x => ({ age: 0 }));
        mr.rooms[roomIx].kidsAges = mr.rooms[roomIx].kids;
        mr.rooms[roomIx].isUpdated = true;
        this.setState({ modifiedReservation: mr },
            this.disableAvailabilityButton);
    };

    handleKidsAgeChange = (roomIx, kidIx, age) => {
        let mr = _cloneDeep(this.state.modifiedReservation);
        let room = mr.rooms[roomIx];
        room.isUpdated = room.isUpdated || room.kids[kidIx].age !== age;
        room.kids[kidIx].age = age;
        //copy kids ages
        room.kidsAges = room.kids;
        mr.rooms[roomIx] = room;
        this.setState({ modifiedReservation: mr },
            this.disableAvailabilityButton);
    };

    handleAddNewRoom = () => {
        let mr = _cloneDeep(this.state.modifiedReservation);
        let newRoom = {
            adults: 2,
            kids: [],
            mealPlan: 'ALL',
            mealPlanDescription: this.props.t('MEALPLANS.ALL'),
            isUpdated: true,
            isDeleted: false,
            isNewRoom: true,
            roomCount: 1,
        };
        mr.rooms.push(newRoom);
        this.setState({ modifiedReservation: mr }, this.disableAvailabilityButton);

    };

    handleRemoveRoom = (room, idx) => {
        let mr = _cloneDeep(this.state.modifiedReservation);
        room.isDeleted = true;
        room.isUpdated = true;
        if (mr.rooms) {
            mr.rooms.splice(idx, 1);
        }
        this.setState({ modifiedReservation: mr });
    };

    handleRoomCountChange = (idx, count) => {
        let mr = _cloneDeep(this.state.modifiedReservation);
        mr.rooms[idx].isUpdated = true;
        mr.rooms[idx].quantity = count;
        mr.rooms[idx].roomCount = count;
        this.setState({ modifiedReservation: mr },
            this.disableAvailabilityButton);
    };

    formatObservations = observations => {
        let obs = Array.isArray(observations) ? observations.join('\n') : observations.replace(/\\r\\n/, '\n');
        return obs;
    };

    getTotalSelectedRooms = () => {
        const rooms = this.state.modifiedReservation.rooms;
        return rooms
            .filter(room => room.isDeleted !== true)
            .reduce((acc, cv) => acc + cv.roomCount, 0);
    };

    buildRoomCountValues = room => {
        const availableRoomsCount = ReservationModifyView.MAX_ROOMS + 1 - this.getTotalSelectedRooms() + room.roomCount;
        let roomCountValues = Array.from(Array(availableRoomsCount).keys());
        roomCountValues.shift();
        return roomCountValues;
    };

    updatesWereMade = () => {
        const { modifiedReservation, reservation } = this.state;
        const dateUpdated = modifiedReservation.dateUpdated ?
            modifiedReservation.dateUpdated : false;
        return (
            modifiedReservation.rooms.some(r => r.isUpdated) ||
            modifiedReservation.rooms.some(r => r.isDeleted) ||
            reservation.checkIn !== modifiedReservation.checkIn ||
            reservation.checkOut !== modifiedReservation.checkOut ||
            dateUpdated
        );
    };

    disableAvailabilityButton = () => {
        let disable = !this.updatesWereMade();
        this.setState({ disableAvailabilityButton: disable });
    };

    backToView = () => {
        window.location.href = window.location.href.replace('modify', 'view');
    }

    getObservationsChecks() {
        let { observationsChecks } = this.state;
        const { hotelObservations } = this.state.reservation;
        const filteredChecks = observationsChecks.map(check => {
            check.checked = !!hotelObservations.find(val => val.id === check.value);
            return check;
        });
        this.setState({ observationsChecks: filteredChecks });
    }

    getObservations() {
        const { hotelObservations } = this.state.reservation;
        let obs = [];
        obs = hotelObservations && hotelObservations.length && hotelObservations.find(val => val.id === 1) ? hotelObservations.find(val => val.id === 1).description : '';
        this.setState({ observations: obs });
    }

    setObservationsChecks(check, value) {
        let checks = this.state.observationsChecks;
        const checkSelected = checks.find(val => val.value === Number(value));
        checkSelected.checked = !checkSelected.checked;
        this.setState({ observationsCheks: checks });
    }

    setObservation(value) {
        this.setState({ observations: value });
    }

    render() {
        const { classes, t } = this.props;
        const { reservation, modifiedReservation } = this.state;
        const { cancellationInsurance } = reservation && reservation.hotel ? reservation.hotel : {};
        const adultValues = Array.from(Array(10).keys());
        const kidsValues = Array.from(Array(5).keys());
        const agesValues = Array.from(Array(19).keys());
        let hasEmptyObservations = false;
        if (reservation && reservation.hotelObservations && reservation.hotelObservations.length === 1) {
            hasEmptyObservations = reservation.hotelObservations[0].description === '';
        } else if (reservation && reservation.hotelObservations && reservation.hotelObservations.length > 1) {
            hasEmptyObservations = false;
        } else {
            hasEmptyObservations = true;
        }
        return (
            <div className="cmsModification">
                <div className="cmsContainer">
                    {this.state.loading ? (
                        <div>
                            <div className="cmsContainer">
                                {this.state.info}
                                <LinearProgress className="cmsProgressBar" />
                            </div>
                        </div>
                    ) : ''}
                    <div className="cmsStatus">
                        <div className={classes.expansionPanelFilter}>
                            <ReservationStatusRender reservation={this.state.reservation} message={t('MODIFY_BOOKING.BOOKING_STATE') + ': '} />
                            <div>
                                <Typography className={classes.locatorTitle}>
                                    {t('MODIFY_BOOKING.BOOKING_LOCATOR') + ': '}
                                    <span>
                                        {this.state.reservationId}
                                        {cancellationInsurance && cancellationInsurance.active === 'SI' &&
                                            <a href="../../../assets/Clausulas SEGURO ANULACION_ESP.pdf" style={{ textDecoration: 'none' }} target='_blank'>
                                                <DynIcon icon="Info" />
                                                {t('BOOKINGS.CANCELLATION_INSURANCE_INCLUDED')}
                                            </a>
                                        }
                                    </span>
                                </Typography>
                            </div>
                        </div>
                    </div>
                    <Grid container justify={'space-between'} alignItems={'stretch'} className={classes.gridContainer}>
                        <Grid item xs={12}>
                            <Paper>
                                <HotelHeaderRender expanded={this.state.expanded} hotel={reservation ? reservation.hotel : null} />
                            </Paper>
                        </Grid>
                        <Grid item xs={12} className="cmsReservationData">
                            <ReservationDetailsRender reservation={reservation} cancellationInsurance={cancellationInsurance} displayprice={true} />
                            {reservation && reservation.hotel &&
                                <ReservationPricesRender
                                    reservation={reservation}
                                    cancellationInsurance={reservation.hotel.cancellationInsurance}
                                    displayToolTip={this.accountName == 'b2bweberoski'}
                                    onlyShowPVP={!getValue(netPrice, this.accountName)}
                                />
                            }
                            {reservation ? (
                                <Paper className={classes.paperFrame}>
                                    <Typography className={classes.bookingTitle}>
                                        {t('MODIFY_BOOKING.MODIFY')}
                                    </Typography>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <ModifyDatesView
                                                reservation={reservation}
                                                modifiedReservation={modifiedReservation}
                                                setDateFilters={this.handleDateChange}
                                                title={t('MODIFY_BOOKING.MODIFY_DATES')}
                                            />
                                        </Grid>

                                        {/*
                                        DATOS RESERVA
                                    */}
                                        <Grid container item xs={12} id="bookingdetails">
                                            <Grid item xs={12}>
                                                <Typography className={classes.title}>
                                                    {t('MODIFY_BOOKING.BOOKING_DATA')}
                                                </Typography>
                                            </Grid>

                                            <Grid container item xs={12}>
                                                <Grid item xs={12}>
                                                    <Grid
                                                        container
                                                        item
                                                        xs={12}>
                                                        <Grid
                                                            item
                                                            xs={2}
                                                            className={classNames(classes.colTitle, classes.firstColTitle)}>
                                                            {t('MODIFY_BOOKING.ROOMS')}
                                                        </Grid>
                                                        <Grid item xs={3} className={classes.colTitle}>
                                                            {t('MODIFY_BOOKING.MEAL_PLAN')}
                                                        </Grid>
                                                        <Grid item xs={2} className={classes.colTitle}>
                                                            {t('MODIFY_BOOKING.ADULTS')}
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={1}
                                                            className={classes.colTitle}
                                                            style={{ textAlign: 'left' }}>
                                                            {t('MODIFY_BOOKING.CHILDREN')}
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={4}
                                                            className={classes.colTitle}
                                                            style={{ textAlign: 'left' }}>
                                                            {t('MODIFY_BOOKING.CHILDREN_AGES')}
                                                        </Grid>
                                                    </Grid>
                                                    {modifiedReservation.rooms &&
                                                        modifiedReservation.rooms.map((room, idx) => {
                                                            const { quantity, order, isDeleted, isUpdated, mealPlan, originalMealPlan } = room;
                                                            let roomCount = quantity;
                                                            return (
                                                                <Grid container item xs={12} key={order} className="formContainer">
                                                                    <Grid
                                                                        container
                                                                        item
                                                                        xs={2}
                                                                        className={classes.colValueEdit}>
                                                                        <Grid item xs={2} className={classes.changeTooltipContainer}>
                                                                            {!isDeleted && isUpdated ? (
                                                                                <Tooltip title={t('CONFIRM_MODIFY_BOOKING.BOOKING_MODIFIED')} enterDelay={200}>
                                                                                    <UpdateIcon className={classes.updateIcon} />
                                                                                </Tooltip>
                                                                            ) : (
                                                                                    ''
                                                                                )}
                                                                        </Grid>
                                                                        <Grid item xs={5}>
                                                                            <TextField
                                                                                select
                                                                                className={classes.textField}
                                                                                name={'roomCount'}
                                                                                value={roomCount || 1}
                                                                                onChange={event =>
                                                                                    this.handleRoomCountChange(idx, event.target.value)
                                                                                }
                                                                                SelectProps={{ MenuProps: { className: classes.menu } }}
                                                                                InputProps={{ classes: { input: classes.textFieldInput } }}
                                                                                disabled={isDeleted}>
                                                                                {this.buildRoomCountValues(room).map(option => (
                                                                                    <MenuItem key={option} value={option}>{option}</MenuItem>
                                                                                ))}
                                                                            </TextField>
                                                                        </Grid>
                                                                    </Grid>

                                                                    <Grid
                                                                        item
                                                                        xs={3}
                                                                        className={classes.colValueEdit}>
                                                                        {
                                                                            room.isNewRoom ?
                                                                                (
                                                                                    <Typography className={classes.fixedMealPlan}>
                                                                                        {t(`MEALPLANS.${mealPlan}`)}
                                                                                    </Typography>
                                                                                )

                                                                                : (<TextField
                                                                                    select
                                                                                    name={'mealPlans'}
                                                                                    className={'editTextField'}
                                                                                    value={room.mealPlan}
                                                                                    onChange={event =>
                                                                                        this.handleMealPlanChange(idx, event.target.value)
                                                                                    }
                                                                                    SelectProps={{
                                                                                        MenuProps: { className: classes.menu },
                                                                                    }}
                                                                                    InputProps={{ classes: { input: classes.textFieldInput } }}
                                                                                    disabled={isDeleted}>
                                                                                    {['ALL', originalMealPlan].map(key => {
                                                                                        return (
                                                                                            <MenuItem key={key} value={key}>
                                                                                                {' '}
                                                                                                {t(`MEALPLANS.${key}`)}{' '}
                                                                                            </MenuItem>
                                                                                        );
                                                                                    })}
                                                                                </TextField>
                                                                                )
                                                                        }

                                                                    </Grid>

                                                                    <Grid
                                                                        item
                                                                        xs={2}
                                                                        className={classes.colValueEdit}
                                                                    >
                                                                        <TextField
                                                                            select
                                                                            className={classes.textField}
                                                                            name={'adults'}
                                                                            value={Number.parseInt(room.adults)}
                                                                            onChange={event => this.handleAdultChange(idx, event.target.value)}
                                                                            SelectProps={{ MenuProps: { className: classes.menu } }}
                                                                            InputProps={{ classes: { input: classes.textFieldInput } }}
                                                                            disabled={isDeleted}>
                                                                            {adultValues.map(option => (
                                                                                <MenuItem key={option} value={option}>
                                                                                    {' '}
                                                                                    {option}{' '}
                                                                                </MenuItem>
                                                                            ))}
                                                                        </TextField>
                                                                    </Grid>

                                                                    <Grid
                                                                        container
                                                                        item
                                                                        xs={1}
                                                                        className={classes.colValueEdit}>
                                                                        <Grid item xs={2}>
                                                                            <TextField
                                                                                select
                                                                                name={'kids'}
                                                                                value={room.kids ? room.kids.length : 0}
                                                                                onChange={event =>
                                                                                    this.handleKidsChange(idx, event.target.value)
                                                                                }
                                                                                SelectProps={{ MenuProps: { className: classes.menu } }}
                                                                                InputProps={{ classes: { input: classes.textFieldInput } }}
                                                                                margin="normal"
                                                                                disabled={isDeleted}>
                                                                                {kidsValues.map(option => (
                                                                                    <MenuItem key={option} value={option}>
                                                                                        {' '}
                                                                                        {option}{' '}
                                                                                    </MenuItem>
                                                                                ))}
                                                                            </TextField>
                                                                        </Grid>

                                                                    </Grid>

                                                                    <Grid
                                                                        container
                                                                        item
                                                                        xs={4}
                                                                        className={classes.colValueEdit + ' cmsChildrenAges'}
                                                                    >
                                                                        <Grid item xs={10}>
                                                                            {room.kids ? room.kids.map((kid, kidIdx) => {
                                                                                return (
                                                                                    <TextField
                                                                                        key={kidIdx}
                                                                                        select
                                                                                        name={'age'}
                                                                                        className={classes.kidsAge}
                                                                                        value={kid.age}
                                                                                        onChange={event =>
                                                                                            this.handleKidsAgeChange(
                                                                                                idx,
                                                                                                kidIdx,
                                                                                                event.target.value,
                                                                                            )
                                                                                        }
                                                                                        SelectProps={{ MenuProps: { className: classes.menu } }}
                                                                                        InputProps={{
                                                                                            classes: { input: classes.textFieldInput },
                                                                                        }}
                                                                                        margin="normal"
                                                                                        disabled={isDeleted}>
                                                                                        {agesValues.map(option => (
                                                                                            <MenuItem key={option} value={option}>
                                                                                                {' '}
                                                                                                {option}{' '}
                                                                                            </MenuItem>
                                                                                        ))}
                                                                                    </TextField>
                                                                                );
                                                                            }) : ''}
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            {!isDeleted ? (
                                                                                <Button
                                                                                    variant="flat"
                                                                                    mini
                                                                                    color="primary"
                                                                                    onClick={event => {
                                                                                        this.handleRemoveRoom(room, idx);
                                                                                    }}>
                                                                                    <Tooltip title={t('CONFIRM_MODIFY_BOOKING.DELETE_ROOM')} enterDelay={200}>
                                                                                        <RemoveIcon />
                                                                                    </Tooltip>
                                                                                </Button>
                                                                            ) : (
                                                                                    ''
                                                                                )}
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            );
                                                        })}
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        {/*
                                        MODIFICATION BUTTONS
                                    */}
                                        <Grid container item xs={12} style={{ paddingLeft: 0 }}>
                                            <Grid item xs={2} className={classes.buttonContainer}>
                                                <Button
                                                    color={'primary'}
                                                    component="a"
                                                    className={classes.button}
                                                    onClick={this.handleAddNewRoom}
                                                    disabled={this.getTotalSelectedRooms() >= ReservationModifyView.MAX_ROOMS}>
                                                    <RoomIcon />
                                                    <Typography variant="button" noWrap={true} className={classes.buttonLabel}>
                                                        {t('MODIFY_BOOKING.ADD_ROOM_BUTTON')}
                                                    </Typography>
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            ) : (
                                    ''
                                )}

                            {/*
                        OBSERVATIONS
                    */}
                            {!hasEmptyObservations && 
                                <ReservationObservationsRender
                                    reservation={reservation}
                                    checks={this.state.observationsChecks}
                                    isNew={this.state.isNew}
                                />
                            }
                            {reservation && reservation.importantNotes && 
                                    <ReservationTermsRender reservation={reservation} />
                                }
                            <Grid container item xs={12}>
                                <Grid item xs={12} >
                                    <Button
                                        color={'primary'}
                                        component="a"
                                        className={classes.button}
                                        onClick={this.handleModifyObservationsClick}
                                        disabled={false}>
                                        <EditIcon />
                                        <Typography variant="button" noWrap={true} className={classes.buttonLabel}>
                                            {t('MODIFY_BOOKING.MODIFY_OBSERVATIONS_BUTTON')}
                                        </Typography>
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>

                        {/*
                        UNDO CHANGES / RECALCULATE RESERVATION
                    */}
                        <Grid container>
                            <Grid container item xs={12} direction={'row'} justify={'flex-end'}>
                                <Button
                                    variant="raised"
                                    color={'secondary'}
                                    component="a"
                                    onClick={() => {
                                        this.backToView();
                                        return false;
                                    }}
                                    disabled={this.state.loading}
                                    className={'thinText'}>
                                    <UndoIcon />
                                    <Typography variant="button" noWrap={true}>
                                        {t('MODIFY_BOOKING.BACK_TO_DETAIL_BUTTON')}
                                    </Typography>
                                </Button>
                                <Button
                                    variant="raised"
                                    color={'primary'}
                                    component="a"
                                    onClick={this.handleSubmit}
                                    disabled={this.state.disableAvailabilityButton}
                                    className={'thinText'}>
                                    <CheckIcon />
                                    <Typography variant="button" noWrap={true}>
                                        {t('MODIFY_BOOKING.RECALCULATE_BOOKING_BUTTON')}
                                    </Typography>
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <ReservationAvailabilityDialog
                        open={this.state.isModalOpen}
                        error={this.state.availabilityError}
                        data={this.state.availabilityData}
                        modifiedReservation={this.state.modifiedReservation}
                        onClose={this.closeModal} />
                    <ReservationObservationsDialog
                        open={this.state.obsInEditMode}
                        data={this.state.observations}
                        checks={this.state.observationsChecks}
                        onCheckboxChange={(check, value) => {
                            this.setObservationsChecks(check, value);
                        }}
                        onChangeObservation={(value) => {
                            this.setObservation(value);
                        }}
                        reservationId={this.state.reservationId}
                        onClose={this.closeObservationsModal}
                    />
                </div>
            </div>
        );
    }


}

export default translate('translations')(withStyles(styles)(ReservationModifyView));



// WEBPACK FOOTER //
// ./src/components/Reservation/Modification/ReservationModifyView.js